import AuthManager from './authManager';
import colors from './colors';
import device from './device';
import * as errors from './errors';
import * as helpers from './helpers';
import { storage } from './storage';

// named export custom events that are required within the component-library project
export * as constants from './constants';
export * as date from './date';
export * as api from './api';
export type { IAuthManager } from './authManager';
export type { Methods as StorageMethods } from './storage';
export * as events from './events';
export * as Styling from './styled';
export { GlobalStyles, StyledGlobalCss } from './globalStyles';
export { device, colors, errors, storage, helpers, AuthManager };
export * from './getInputType';

// Todo: Get rid of it
// export custom utility methods that can be consumed both in the library and related transactions
export default {
  errors,
  AuthManager,
  helpers,
  storage,
  device,
  colors
};
